const BookingRoutes = {
  getMoving: "/getMoving",
  getCarService: "/getCarService",
  assignDriver: "/assignDriver",
  deleteMoving: "/deleteMoving",
};

export default BookingRoutes;
